import React, { useContext, createContext, useState } from "react";
import * as HTTPServices from "../api/HTTPServices";
import * as DataServices from "../api/DataServices";

/** For more details on
 * `authContext`, `ProvideAuth`, `useAuth` and `useProvideAuth`
 * refer to: https://usehooks.com/useAuth/
 */
const authContext = createContext();

export function ProvideAuth({ children }) {
  const auth = useProvideAuth();
  return <authContext.Provider value={auth}>{children}</authContext.Provider>;
}

export function useAuth() {
  return useContext(authContext);
}

const authentication = {
  isAuthenticated: false,
  signin(username, code, approve) {
    const params = new URLSearchParams();
    //Persian Num to ENG
    const p2e = (s) => s.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
    const a2e = (s) => s.replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d));
    username = p2e(username);
    username = a2e(username);
    //END

    if (Number.isInteger(parseInt(username))) {
      params.append("mobile", username);
    } else {
      params.append("email", username);
    }
    params.append("code", code);
    params.append("approve", approve);

    const RequestService = HTTPServices.postMethod("validate_v2", params);
    RequestService.then(function (response) {
      if (response) {
        authentication.isAuthenticated = true;
        return response;
      } else {
      }
    }).catch(function (error) {});
    return;
  },
  signout(cb) {
    authentication.isAuthenticated = false;
    setTimeout(cb, 100);
  },
};

function useProvideAuth() {
  const [user, setUser] = useState(null);

  const confirmLogin = (username, code, approve) => {
    const params = new URLSearchParams();

    //Persian Num to ENG
    const p2e = (s) => s.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
    const a2e = (s) => s.replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d));
    username = p2e(username);
    username = a2e(username);
    //END

    if (Number.isInteger(parseInt(username))) {
      params.append("mobile", username);
    } else {
      params.append("email", username);
    }
    params.append("code", code);
    params.append("approve", approve);

    const RequestService = HTTPServices.postMethod("validate_v2", params);
    RequestService.then(function (response) {
      if (response) {
        window.localStorage.setItem("access_token", response.access_token);
        window.localStorage.setItem("token_echo", response.access_token);

        var d = new Date();
        d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);
        var expires = "expires=" + d.toUTCString();

        document.cookie = `access_token_sbm=${
          response.access_token
        };${expires};path=/;domain=${DataServices.webConfig("cookie_key")}`;
        document.cookie = `user_id=${
          response.user_id
        };${expires};path=/;domain=${DataServices.webConfig("cookie_key")}`;
        document.cookie = `approve=${
          response.approve
        };${expires};path=/;domain=${DataServices.webConfig("cookie_key")}`;
        document.cookie = `user_image=${
          response.user_image
        };${expires};path=/;domain=${DataServices.webConfig("cookie_key")}`;

        var name = response.nick_name
          ? response.nick_name + " " + response.full_name
          : response.full_name;
        document.cookie = `user_name=${name};${expires};path=/;domain=${DataServices.webConfig(
          "cookie_key"
        )}`;
        setUser(response);
        return response;
      } else {
      }
    }).catch(function (error) {});
    return;
  };

  const confirmPassword = (username, code, approve) => {
    const params = new URLSearchParams();

    //Persian Num to ENG
    const p2e = (s) => s.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
    const a2e = (s) => s.replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d));
    username = p2e(username);
    username = a2e(username);
    //END

    if (Number.isInteger(parseInt(username))) {
      params.append("mobile", username);
    } else {
      params.append("email", username);
    }
    params.append("password", code);
    params.append("approve", approve);

    const RequestService = HTTPServices.postMethod("loginv2", params);
    RequestService.then(function (response) {
      if (response) {
        window.localStorage.setItem("access_token", response.access_token);
        window.localStorage.setItem("token_echo", response.access_token);

        var d = new Date();
        d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);
        var expires = "expires=" + d.toUTCString();

        document.cookie = `access_token_sbm=${
          response.access_token
        };${expires};path=/;domain=${DataServices.webConfig("cookie_key")}`;
        document.cookie = `user_id=${
          response.user_id
        };${expires};path=/;domain=${DataServices.webConfig("cookie_key")}`;
        document.cookie = `approve=${
          response.approve
        };${expires};path=/;domain=${DataServices.webConfig("cookie_key")}`;
        document.cookie = `user_image=${
          response.user_image
        };${expires};path=/;domain=${DataServices.webConfig("cookie_key")}`;

        var name = response.nick_name
          ? response.nick_name + " " + response.full_name
          : response.full_name;
        document.cookie = `user_name=${name};${expires};path=/;domain=${DataServices.webConfig(
          "cookie_key"
        )}`;
        setUser(response);
        return response;
      } else {
      }
    }).catch(function (error) {});
    return;
  };

  const signout = async () => {
    const params = new URLSearchParams();
    await HTTPServices.postMethod("signOut", params, "true");
    document.cookie =
      "access_token_sbm=;path=/;domain=" + DataServices.webConfig("cookie_key");
    document.cookie =
      "user_id=;path=/;domain=" + DataServices.webConfig("cookie_key");
    document.cookie =
      "approve=;path=/;domain=" + DataServices.webConfig("cookie_key");
    document.cookie =
      "user_image=;path=/;domain=" + DataServices.webConfig("cookie_key");
    document.cookie =
      "user_name=;path=/;domain=" + DataServices.webConfig("cookie_key");
    localStorage.removeItem("access_token");
    localStorage.removeItem("redirectToprevPage");
    window.location = "/login";
    setUser(null);
  };

  return {
    user,
    confirmLogin,
    confirmPassword,
    signout,
  };
}

export const loginUser = (username) => {
  const params = new URLSearchParams();
  //Persian Num to ENG
  const p2e = (s) => s.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
  const a2e = (s) => s.replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d));
  username = p2e(username);
  username = a2e(username);
  //END

  if (Number.isInteger(parseInt(username))) {
    params.append("mobile", username);
  } else {
    params.append("email", username);
  }

  const RequestService = HTTPServices.postMethod("login_v2", params);
  RequestService.then(function (response) {
    if (response) {
      console.log("response", response);
    } else {
    }
  }).catch(function (error) {});
};

export function getCookie(cname) {
  const name = cname + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function getAuthorization() {
  var token = getCookie("access_token_sbm");
  //if(!token) token = window.localStorage.getItem('access_token_sbm');

  window.localStorage.setItem("token_echo", token);

  return token;
}
